import { render, staticRenderFns } from "./projectHistory.vue?vue&type=template&id=9c78e70a&scoped=true&"
import script from "./projectHistory.vue?vue&type=script&lang=js&"
export * from "./projectHistory.vue?vue&type=script&lang=js&"
import style0 from "./projectHistory.vue?vue&type=style&index=0&id=9c78e70a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c78e70a",
  null
  
)

export default component.exports